import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import LoadingButton from '../../../UI/LoadingButton';

const SensorReportPage = (props) => {
  const { t, isSubmitting } = props;
  const onClick = (format) => {
    props.onClick(format);
  };
  return (
    <Backend>
      <div className="content-inner">
        <div>
          <LoadingButton
            id="pdf-export"
            classes="button button-primary mr-20"
            loading={isSubmitting}
            onClick={(e) => {
              e.preventDefault();
              onClick('pdf');
            }}
          >
            {t('PDF')}
          </LoadingButton>
          <LoadingButton
            id="excel-export"
            classes="button button-primary mr-20"
            loading={isSubmitting}
            onClick={(e) => {
              e.preventDefault();
              onClick('excel');
            }}
          >
            {t('Excel')}
          </LoadingButton>
          <LoadingButton
            id="word-export"
            classes="button button-primary mr-20"
            loading={isSubmitting}
            onClick={(e) => {
              e.preventDefault();
              onClick('word');
            }}
          >
            {t('Word')}
          </LoadingButton>
          <LoadingButton
            id="csv-export"
            classes="button button-primary"
            loading={isSubmitting}
            onClick={(e) => {
              e.preventDefault();
              onClick('csv');
            }}
          >
            CSV
          </LoadingButton>
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(SensorReportPage);
